module.exports = __webpack_public_path__ + "img/testing.8d334180.jpg";